import { InjectionToken } from '@angular/core';

export const LOGGING_FEATURE_FLAG = new InjectionToken<string>('Logging feature flag');
